import { makeStyles } from "@mui/styles";

const formStyle = makeStyles((theme) => ({
  location: {
    backgroundColor: "#008374",
    height: "100%",
    padding: "20px",
    borderRadius: "10px 0 0 10px",
    [theme.breakpoints.down(900)]: {
      borderRadius: "10px 10px 0px 0px",
    },
    boxShadow: "0px 2px 25px rgba(0, 0, 0, 0.1)",
    "&.MuiBox-root .location-container": {
      width: "100%",
      backgroundColor: "#009282",
      marginBottom: "20px",
      padding: "20px 17px",
      borderRadius: "10px",
      color: "#fff",
      display: "flex",
    },
    "&.MuiBox-root .location-container .icon-circle": {
      color: "#fff",
      width: "44px",
      height: "44px",
      backgroundColor: "rgba(255, 255, 255, 0.2)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      borderRadius: "50px",
      transition: "all 0.3s ease-in-out",
    },
  },
  form: {
    width: "100%",
    height: "100%",
    background: "#fff",
    boxShadow: "0px 2px 25px rgba(0, 0, 0, 0.1)",
    padding: "30px",
    borderRadius: "0 10px 10px 0",
    [theme.breakpoints.down(900)]: {
      borderRadius: "0px 0px 10px 10px",
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: "0px !important",
      "&.Mui-focused fieldset": {
        borderColor: "#008374",
      },
    },
    "& .MuiButton-root": {
      backgroundColor: "#008374",
      padding: "14px 45px !important",
      transition: "0.4s",
      borderRadius: "50px",
      boxShadow: "none !important",
      textTransform: "capitalize !important",
      fontSize: "16px !important",
      "&:hover": {
        background: "rgba(0, 131, 116, 0.8) !important",
      },
    },
  },
}));

export default formStyle;
